export const RadioItem = (props) => {
  const { selected, onChange, texthead, textbody, value,id,onKeyDown1=()=>{} } = props
	const notSelected = JSON.stringify(selected) !== JSON.stringify(value);
  return (
    <div
      className="custom-radio-container"
      onClick={() => {onChange(value)
      }}
    >
      <div className={`radio-outer-circle ${notSelected && 'unselected'}`} id={id} tabIndex={0} onKeyDown={(e)=>onKeyDown1(e)}>
        <div className={`radio-inner-circle ${notSelected && 'unselected-circle'}`} />
      </div>
      <div className="radio-text">
        <div className="text-head">{texthead}</div>
        <div className="text-body">{textbody} </div>
      </div>
    </div>
  )
}
